import { render, staticRenderFns } from "./DateFacet.vue?vue&type=template&id=66196f36&"
import script from "./DateFacet.vue?vue&type=script&lang=js&"
export * from "./DateFacet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports